export default {
  '语言切换': '语言切换',
  "手机号登录":"手机号登录",
  "邮箱号登录":"邮箱号登录",
  "请输入手机号":"请输入手机号",
  "请输入邮箱号":"请输入邮箱号",
  "请输入密码":"请输入密码",
  "验证码登录":"验证码登录",
  "登录":"登录",
  "忘记密码":"忘记密码",
  "注册":"注册",
  "已阅读并同意":"已阅读并同意",
  "用户注册协议":"用户注册协议",
  "与":"与",
  "隐私政策":"隐私政策",
  "密码登录":"密码登录",
  "请输入验证码":"请输入验证码",
  "获取验证码":"获取验证码",
  "秒后重新获取":"秒后重新获取",
  "手机号注册":"手机号注册",
  "邮箱号注册":"邮箱号注册",
  "确定":"确定",
  "手机号找回":"手机号找回",
  "邮箱号找回":"邮箱号找回",
  "专业外卖平台":"专业外卖平台",
  "退出":"退出",
  "确定要退出么？":"确定要退出么？",
  "客服二维码":"客服二维码",
  "点单界面":"点单界面",
  "简体中文":"简体中文",
  "英文":"英文",
  "切换语言":"切换语言",
  "返回":"返回",
  "两菜点餐":'两菜点餐',
  "三菜点餐":'三菜点餐',
  "选择配送地址":"选择配送地址",
  "新增地址":"新增地址",
  "暂无可用地址":"暂无可用地址",
  "温馨提示":"温馨提示",
  "选中的日期都需要选择菜品哦":"选中的日期都需要选择菜品哦",
  "知道了":"知道了",
  "饭票不足，请前往充值":"饭票不足，请前往充值",
  "稍后再说":"稍后再说",
  "立即充值":"立即充值",
  "个人中心":"个人中心",
  "预约":'预约',
  "历史订单":"历史订单",
  "收货地址":"收货地址",
  "设置":"设置",
  "绑定企业":"绑定企业",
  "饭票":"饭票",
  "详情":"详情",
  "充值":"充值",
  "我的预约":"我的预约",
  "您目前没有即将送餐的订单":"您目前没有即将送餐的订单",
  "前往预定":"前往预定",
  "审核中":"审核中",
  "绑定企业":"绑定企业",
  "绑定企业后，不可修改，请谨慎操作":"绑定企业后，不可修改，请谨慎操作",
  "请输入企业名称":"请输入企业名称",
  "搜索":"搜索",
  "绑定":"绑定",
  "请输入企业名称":"请输入企业名称",
  "取消":"取消",
  "确认":"确认",
  "确定绑定":"确定绑定",
  "吗":"吗",
  "提交绑定后，将不可修改请谨慎操作":"提交绑定后，将不可修改请谨慎操作",
  "我的饭票":"我的饭票",
  "饭票明细":"饭票明细",
  "充值":"充值",
  "个人饭票":"个人饭票",
  "张":"张",
  "2菜饭票":"2菜饭票",
  "3菜饭票":"3菜饭票",
  "朋友饭票":"朋友饭票",
  "个人":"个人",
  "好友":"好友",
  "三菜":"三菜",
  "二菜":"二菜",
  "饭票充值":"饭票充值",
  "套餐购买，默认自动续费。在饭票低于5张时候，自动充值。可在个人中心设置里面进行取消":"套餐购买，默认自动续费。在饭票低于5张时候，自动充值。可在个人中心设置里面进行取消",
  "立即充值":"立即充值",
  "查看充值订单":"查看充值订单",
  "支付金额":"支付金额",
  "微信支付":"微信支付",
  "支付宝支付":"支付宝支付",
  "微信扫码支付":"微信扫码支付",
  "支付宝扫码支付":"支付宝扫码支付",
  "支付成功":"支付成功",
  "返回个人中心":"返回个人中心",
  "充值订单":"充值订单",
  "手动充值":"手动充值",
  "自动划扣":"自动划扣",
  "预约":"预约",
  "配送中":"配送中",
  "暂无预约":"暂无预约",
  "预订更多":"预订更多",
  "份":"份",
  "已完成":"已完成",
  "已取消":"已取消",
  "历史订单":"历史订单",
  "订单详情":"订单详情",
  "配送日期":"配送日期",
  "待配送":"待配送",
  "订单信息":"订单信息",
  "订单编号":"订单编号",
  "下单时间":"下单时间",
  "取消订单":"取消订单",
  "联系客服":"联系客服",
  "预约套餐":"预约套餐",
  "两菜饭票":"两菜饭票",
  "三菜饭票":"三菜饭票",
  "下单成功":"下单成功",
  "查看预约":"查看预约",
  "返回首页":"返回首页",
  "确定要取消订单吗？取消后，订单饭票将退回":"确定要取消订单吗？取消后，订单饭票将退回",
  "稍后再说":"稍后再说",
  "确认取消":"确认取消",
  "已退回":"已退回",
  "收货人":"收货人",
  "联系方式":"联系方式",
  "地址":"地址",
  "操作":"操作",
  "编辑":"编辑",
  "删除":"删除",
  "默认地址":"默认地址",
  "设置默认地址":"设置默认地址",
  "添加地址":"添加地址",
  "选择地址":"选择地址",
  "请选择":"请选择",
  "联系人":"联系人",
  "请输入收货人":"请输入收货人",
  "先生":"先生",
  "女士":"女士",
  "联系电话":"联系电话",
  "详细地址":"详细地址",
  "请输入详细地址，以便师傅配送":"请输入详细地址，以便师傅配送",
  "提示":"提示",
  "确定要删除该地址吗":"确定要删除该地址吗",
  "我的消息":"我的消息",
  "平台公告":"平台公告",
  "订单通知":"订单通知",
  "已读":"已读",
  "未读":"未读",
  "客服工作时间":"客服工作时间",
  "修改登录密码":"修改登录密码",
  "修改绑定邮箱号":"修改绑定邮箱号",
  "修改绑定手机号":"修改绑定手机号",
  "当饭票低于":"当饭票低于",
  "张的时候，自动充值":"张的时候，自动充值",
  "旧密码验证":"旧密码验证",
  "手机号验证":"手机号验证",
  "邮箱号验证":"邮箱号验证",
  "旧密码":"旧密码",
  "请输入旧密码":"请输入旧密码",
  "新密码":"新密码",
  "请输入新密码":"请输入新密码",
  "确认新密码":"确认新密码",
  "请再次输入新密码":"请再次输入新密码",
  "我们要对您绑定的手机号进行验证":"我们要对您绑定的手机号进行验证",
  "验证码":"验证码",
  "请输入验证码":"请输入验证码",
  "我们要对您绑定的邮箱号进行验证":"我们要对您绑定的邮箱号进行验证",
  "新的手机号":"新的手机号",
  "新的邮箱号":"新的邮箱号",
  "请勾选协议":"请勾选协议",
  "请选择地址":"请选择地址",
  "选择":"选择",
  "套餐":"套餐",
  "请输入详细地址":"请输入详细地址",
  "添加成功":"添加成功",
  "编辑成功":"编辑成功",
  "确定要删除该地址吗？":"确定要删除该地址吗？",
  "待支付":"待支付",
  "拼命加载中":"拼命加载中",
  "两次输入密码不一致":"两次输入密码不一致",
  "门牌号":"门牌号",
  "请输入门牌号":"请输入门牌号",
  "街道名称":"街道名称",
  "请输入街道名称":"请输入街道名称",
  "州邮编":"州邮编",
  "请输入州邮编":"请输入州邮编",
  "额外赠送":"额外赠送",
  "张好友饭票":"张好友饭票",
  "请选择菜品":"请选择菜品",
  "备注":"备注",
  "请输入备注":"请输入备注",
};